import moonSignsChange from './actions/moonSignsChange';
import moonSignsCreate from './actions/moonSignsCreate';
import moonSignsDetail from './actions/moonSignsDetail';
import moonSignsList from './actions/moonSignsList';
import getMoonSigns from './getters/getMoonSigns';
import moonSignsUpload from './mutations/moonSignsUpload';

const actions = {
    moonSignsChange,
    moonSignsCreate,
    moonSignsDetail,
    moonSignsList
};

const mutations = {
    moonSignsUpload
};

const getters = {
    getMoonSigns
};

export default { actions, mutations, getters };
